import React from 'react'
import System from "../../../../../helper/system";
import Order from "@system/config/order";
import { useOrderStore } from 'src/hooks/order';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Constants from "src/helper/Constants";

const OrderInfoHeader = () => {
    const [{ order_detail }, {  }, { export_order }] = useOrderStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const isCoreUser = System.avUserInfoData.currentUser === Constants.siteUser.CORE

    const exportOrder = async (orderNumber, webOrderNumber) => {
        await export_order({
            orderNumber: orderNumber,
            webOrderNumber: webOrderNumber
        }) 
        system_alert_indicator({
            name: 'ExportOrder',
            message: "The document successfully downloaded.",
            type: "success"
        })
    }
    return (
        <>
            <div className="pcn-page-head header-container d-flex align-items-center justify-sm-content-between flex-wrap flex-sm-nowrap">
                <div className="page-title font-oswald font-light font-30 mb-3 mb-sm-0">Order Details</div>
                <div className="ms-sm-auto mb-0">
                    <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-0">
                        {isCoreUser && <li className="ms-sm-4 font-13 font-arial"><a className='d-flex align-items-center'
                            href={void (0)} data-toggle="modal" data-target="#EmailSales" onClick={() => {
                                System.popup('OrderDetailEmailSalesPopup', {
                                    "emailTo":order_detail?.smrEmail
                                });
                            }}><i className="fa fa-envelope me-2 text-black" aria-hidden="true"></i> Email</a></li>}
                        <li className="ms-4 font-13 font-arial"
                            onClick={() => exportOrder(order_detail?.salesOrderNumber, order_detail?.webOrderNumber)}>
                            <a className='d-flex align-items-center'><i className="file-export-icon me-2 text-black" aria-hidden="true"></i>Export Order</a></li>
                        <li className="ms-4 font-13 font-arial">
                            <a className='d-flex align-items-center' href={void (0)} onClick={() => window.print()}>
                            <i className="fa fa-print me-2 text-black"></i>Print Page</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="pcn-line-divider mb-2" />
          

            <a href={void (0)} className="return-to-order d-flex align-items-center mb-2"
                onClick={() => {
                    window.location.href = Order.getOrderRouteURL();
                }}>
                <i className='return-cart me-1'></i><span>Return to Order History</span>
            </a>
        </>
    )
}

export default OrderInfoHeader